<template>
  <Layout>
    <div class="row">
      <div class="col-12 card">
        <div class="container-fluid">
          <div class="card-body">
            <span v-if="userData.logo!=0"><img :src="getLogo(userData.logo)" height="60"/></span>
            <span v-else><img src="@/assets/images/logo.png" height="60"/></span>
            <table class="table" density="compact" style="color:black">
              <tr><td>Full Name: </td><td class="h4"> {{ patientData.name }}</td>
                <td>Gender: </td><td class="h5"> {{ patientData.gender }} </td> <td> Telephone: </td><td class="h5"> 0{{ patientData.telephone }} </td></tr>
              <tr><td> Age: </td><td class="h5"> {{ getAge(patientData.date_of_birth) }}  </td>
              <td> Address: </td><td class="h5"> {{ patientData.address }} </td></tr>
            </table>
          </div>
          <div class="d-flex justify-content-between">
          <span><router-link :to="{ path: '/entertestresults'}" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-arrow-left"></i> Back</router-link></span>
          </div>
          <h4 class="text-center text-decoration-underline">Laboratory Results</h4>
          <form @submit.prevent="addResults">
            <div class="my-2">
              <table class="table table-sm mt-2" style="color: black;" density="compact">
                <thead><tr><th>Test</th><th>Sample Picked</th><th>Results</th></tr></thead>
                <tbody>
                  <tr v-for="item in patientTest" :key="item.id">
                    <td v-if ="isPaymentTypeValid">{{ item.service.name  }}</td>
                     <td v-else>{{ item.insurance_service.name  }}</td>
                    <!-- <td>{{ item.service && item.service.name ? item.service.name : (item.insurance_service && item.insurance_service.name ? item.insurance_service.name : '') }}</td> -->
                    <td><multiselect v-model="item.sample" :options="labsamples" label="name"></multiselect></td>
                    <td><tinymce :id="`d`+item.id" v-model="item.result"></tinymce></td>
                  </tr>
                </tbody>
              </table>
              <div class="form-group d-flex justify-content-end mt-3">
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
            </div> 
          </form>
          </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
import {labsampleMethods, labsampleComputed,} from "@/state/helpers";

export default {
  page: {
    title: "Patient Lab Results",
    meta: [{name: "description",content: appConfig.description,},],
  },
  components: {
    Layout,Multiselect
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      patientData:[],
      pay_type:'',
      patientTest:[{service:{name:""}, sample: "",result:'',insurance_service:{name:" "} }],
    };
  },
  computed: {
    ...labsampleComputed,
    isPaymentTypeValid() {
          return this.pay_type != '4';
         }, 
  },
  created() {
    this.showpatientinfo();
    this.fetchLabsamples();
  },
  
  methods: {
    ...labsampleMethods,
    // getAge(dateString){
    //   let birth = new Date(dateString); let now = new Date(); let beforeBirth = ((() => {birth.setDate(now.getDate());birth.setMonth(now.getMonth()); return birth.getTime()})() < birth.getTime()) ? 0 : 1;
    //   return now.getFullYear() - birth.getFullYear() - beforeBirth;
    // },
    getAge(dateString) {
  let birth = new Date(dateString);
  let now = new Date();

  let years = now.getFullYear() - birth.getFullYear();
  let months = now.getMonth() - birth.getMonth();

  // Adjust years and months if the current month hasn't reached the birth month yet
  if (months < 0) {
    years--;
    months += 12;
  }

  // Adjust months if the current day hasn't reached the birth day yet
  if (now.getDate() < birth.getDate()) {
    months--;
    if (months < 0) {
      years--;
      months += 12;
    }
  }

  if (years > 0) {
    // return `${years} years and ${months} months old`;
    return `${years} yrs`;

  } else {
    return `${months} months old`;
  }
},
    getLogo(name){
        let url = axios.defaults.baseURL;
        let imagelink = (url).slice(0,-3)+"logos/"+name;
        return imagelink;
      },
      async showpatientinfo(){
      this.visit_id=this.$route.query.id;
      let formData = new FormData();
      formData.append("visit_id", this.visit_id);
      let url = "/findpatientlabinfo";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.patientData=response.data.patient;
        this.showpatienttest();
        }
      })
    },
    async showpatienttest(){
      this.visit_id=this.$route.query.id;
      let formData = new FormData();
      formData.append("visit_id", this.visit_id);
      let url = "/findpatientlabtests";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.patientTest=response.data.labtests;
        this.pay_type = response.data.labtests[0].patientvisit.payment_type;
        }
      })
    },
    async addResults(){
      let obj = {results:this.patientTest, visit_id:this.$route.query.id,patient_id:this.patientData.patient_id }
        let url = "/addpatiettestresults";
        await axios.post(url, obj).then((response) => {
          if (response.status == 200) {
            this.$router.push('/testresultreports');
          }
        });
    }
  },
};
</script>